import React from 'react'
import { CleartripTransactions } from '@/src/components/common/wallet/cleartripTransactions'
import type { CleartripFormattedTransaction } from '@/src/components/common/wallet/cleartripTransactions/cleartripTransactions'
import { WalletPage } from './wallet'

type WalletPageProps = Omit<React.ComponentProps<typeof WalletPage>, 'isCleartrip'>

interface WalletMobileCleartripContentProps {
    walletPageProps: WalletPageProps
    transactions: CleartripFormattedTransaction[]
    hasMoreTransactions: boolean
    isFetchingMore: boolean
    onLoadMore: () => void
    formatAmount: (amount: number, currency: string) => string
    transactionHistoryLabel: string
    noTransactionsLabel: string
    loadMoreLabel: string
    loadingLabel: string
    isRtl?: boolean
}

const WalletMobileCleartripContent = ({
    walletPageProps,
    transactions,
    hasMoreTransactions,
    isFetchingMore,
    onLoadMore,
    formatAmount,
    transactionHistoryLabel,
    noTransactionsLabel,
    loadMoreLabel,
    loadingLabel,
    isRtl = false
}: WalletMobileCleartripContentProps) => {
    return (
        <>
            <WalletPage {...walletPageProps} isCleartrip />
            <CleartripTransactions
                transactions={transactions}
                hasMoreTransactions={hasMoreTransactions}
                isFetchingMore={isFetchingMore}
                onLoadMore={onLoadMore}
                formatAmount={formatAmount}
                transactionHistoryLabel={transactionHistoryLabel}
                noTransactionsLabel={noTransactionsLabel}
                loadMoreLabel={loadMoreLabel}
                loadingLabel={loadingLabel}
                isRtl={isRtl}
            />
        </>
    )
}

export default WalletMobileCleartripContent
